import { useState } from 'react';
import { Box, Button, Typography, makeStyles } from '@material-ui/core';
import { Theme } from 'src/theme';
import CloseIcon from '@material-ui/icons/Close';
import moment from 'moment';
import { getNavigatorLanguage } from 'src/utils/locale';
import { BillingAlertData } from 'src/hooks/useBillingAlert';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: '100%',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    padding: 10,
    justifyContent: 'space-between',
  },
  button: {
    background: '#fff',
    marginLeft: 20,
    '&:hover': {
      background: '#fff',
    },
  },
}));

const BillingBanner = ({
  daysUntilDue,
  isOverdue,
  dueDate,
  amount,
  currency,
  interval,
}: BillingAlertData) => {
  const classes = useStyles();
  const navLanguage = getNavigatorLanguage();

  const [isOpen, setIsOpen] = useState<boolean>(() => {
    const isDismissed = localStorage.getItem(`billing-alert-dismissed-${dueDate}`) === 'true';
    if (isOverdue) return true;
    return !isDismissed;
  });

  const formatCurrency = (amt: number, curr: string) => {
    return `${curr.toUpperCase()} ${(amt / 100).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  const formatDate = (dateString: string) => {
    return moment(dateString).format(
      ['en-US', 'en-CA'].includes(navLanguage) ? 'MM/DD/YYYY' : 'DD/MM/YYYY'
    );
  };

  const handleDismiss = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsOpen(false);
    if (!isOverdue) {
      localStorage.setItem(`billing-alert-dismissed-${dueDate}`, 'true');
    }
  };

  if (!isOpen) return null;

  const backgroundColor = isOverdue ? '#f44336' : '#ff9800';

  return (
    isOpen && (
      <Box className={classes.container} style={{ background: backgroundColor }}>
        <Typography>
          {isOverdue ? (
            <>
              <strong>OVERDUE:</strong> {formatCurrency(amount, currency)} payment overdue (due {formatDate(dueDate)}) - {interval === 'month' ? 'Monthly' : 'Annual'} renewal
            </>
          ) : (
            <>
              <strong>Upcoming Invoice:</strong> {formatCurrency(amount, currency)} due in {daysUntilDue} day{daysUntilDue !== 1 ? 's' : ''} ({formatDate(dueDate)}) - {interval === 'month' ? 'Monthly' : 'Annual'} renewal
            </>
          )}
        </Typography>
        <Button onClick={handleDismiss} className={classes.button} style={{ color: backgroundColor }}>
          <CloseIcon />
        </Button>
      </Box>
    )
  );
};

export default BillingBanner;
